import { routes as inscricoes } from './inscricoes'
import { routes as relatorios } from './relatorios'

export default [
  {
    path: '/centralvagas',
    name: 'Central de Vagas',
    description: 'Central de Vagas',
    children: [
      ...inscricoes,
      ...relatorios
    ],
    goesToMenu: true
  }
]
